module.exports = __webpack_public_path__ + "img/17-l.8de8bcfa.png";